import { FileListFilter, registerFileListFilter } from '@nextcloud/files';
import Vue from 'vue';
import FileListFilterAccount from '../components/FileListFilterAccount.vue';
/**
 * File list filter to filter by owner / sharee
 */
class AccountFilter extends FileListFilter {
    currentInstance;
    filterAccounts;
    constructor() {
        super('files_sharing:account', 100);
    }
    mount(el) {
        if (this.currentInstance) {
            this.currentInstance.$destroy();
        }
        const View = Vue.extend(FileListFilterAccount);
        this.currentInstance = new View({
            el,
        })
            .$on('update:accounts', this.setAccounts.bind(this))
            .$mount();
    }
    filter(nodes) {
        if (!this.filterAccounts || this.filterAccounts.length === 0) {
            return nodes;
        }
        const userIds = this.filterAccounts.map(({ uid }) => uid);
        // Filter if the owner of the node is in the list of filtered accounts
        return nodes.filter((node) => {
            const sharees = node.attributes.sharees?.sharee;
            // If the node provides no information lets keep it
            if (!node.owner && !sharees) {
                return true;
            }
            // if the owner matches
            if (node.owner && userIds.includes(node.owner)) {
                return true;
            }
            // Or any of the sharees (if only one share this will be an object, otherwise an array. So using `.flat()` to make it always an array)
            if (sharees && [sharees].flat().some(({ id }) => userIds.includes(id))) {
                return true;
            }
            // Not a valid node for the current filter
            return false;
        });
    }
    reset() {
        this.currentInstance?.resetFilter();
    }
    setAccounts(accounts) {
        this.filterAccounts = accounts;
        let chips = [];
        if (this.filterAccounts && this.filterAccounts.length > 0) {
            chips = this.filterAccounts.map(({ displayName, uid }) => ({
                text: displayName,
                user: uid,
                onclick: () => this.currentInstance?.toggleAccount(uid),
            }));
        }
        this.updateChips(chips);
        this.filterUpdated();
    }
}
/**
 * Register the file list filter by owner or sharees
 */
export function registerAccountFilter() {
    registerFileListFilter(new AccountFilter());
}
